import { on } from '@ngrx/store';

import { createImmutableReducer } from '../../base/store/helpers';
import BetslipPickActions from '../picks/actions';
import { addGroup, replaceGroup } from '../picks/grouped-picks.actions';
import { pickSelectionHandlers } from '../picks/reducer';
import { addOrderedPicks, removeOrderedTypePicks } from '../picks/services/type-pick.utils';
import BetslipSingleBetActions from './actions';
import { ISingleBetPickState, ISingleBetState, defaultSingleBetState } from './state';

export const singleBetReducer = createImmutableReducer(
    defaultSingleBetState,
    ...pickSelectionHandlers<ISingleBetState>(),
    on(BetslipSingleBetActions.addPick, (state, action) => {
        state.picks[action.pickId] = {
            ...getDefaultPickState(),
            ...action.pickState,
        };

        return state;
    }),
    on(BetslipSingleBetActions.updateOrder, (state, action) => {
        if (state.picks[action.pickId]) {
            state.picks[action.pickId].order = action.order;
        }

        return state;
    }),
    on(BetslipSingleBetActions.removePick, (state, action) => {
        delete state.picks[action.pickId];

        return state;
    }),
    on(BetslipSingleBetActions.setSingleBetPickStake, (state, action) => {
        const pickId = action.pickId;
        if (!state.picks[pickId]) {
            return state;
        }
        state.picks[pickId].stake = action.stake;
        state.picks[pickId].actualStake = action.stakeStr || null;

        return state;
    }),
    on(BetslipSingleBetActions.setSingleBetStake, (state, action) => {
        const pickIds = Object.keys(state.picks);
        for (const pickId of pickIds) {
            state.picks[pickId].stake = action.stake;
            state.picks[pickId].actualStake = action.stakeStr || null;
        }

        return state;
    }),
    on(BetslipSingleBetActions.toggleSingleBetPickEachWay, (state, action) => {
        const pick = state.picks[action.pickId.toString()];
        pick.isEachWay = !pick.isEachWay;

        return state;
    }),
    on(BetslipSingleBetActions.setSingleBetPickEachWay, (state, action) => {
        const pick = state.picks[action.pickId.toString()];
        pick.isEachWay = action.isEachWay;

        return state;
    }),
    on(BetslipSingleBetActions.setSingleBetPicksEachWay, (state, action) => {
        action.pickIds?.forEach((pick) => {
            const statePick = state.picks[pick['id']];
            if (statePick) {
                statePick.isEachWay = action.isEachWay;
            }
        });

        return state;
    }),
    on(BetslipSingleBetActions.setSingleBetPickRewardToken, (state, action) => {
        const { pickId, rewardTokenId } = action;
        state.picks[pickId].rewardTokenId = rewardTokenId;

        return state;
    }),
    on(BetslipSingleBetActions.removeAllSingleBetPickRewardTokens, (state) => {
        for (const pick of Object.values(state.picks)) {
            pick.rewardTokenId = null;
        }

        return state;
    }),
    on(BetslipSingleBetActions.toggleSingleBetPick, (state, action) => {
        const pickId = action.pickId.toString();
        if (!state.picks[pickId]) {
            return state;
        }
        state.picks[pickId].isSelected = !state.picks[pickId].isSelected;

        return state;
    }),
    on(replaceGroup, addGroup, (state, action) => {
        const legs = action.newPick.getLegs();

        addOrderedPicks(legs, state.picks, getDefaultPickState);

        return state;
    }),
    on(BetslipPickActions.removeTypePicks, (state, action) => {
        removeOrderedTypePicks(action.pickIds, state.picks);

        return state;
    }),
);

function getDefaultPickState(): ISingleBetPickState {
    return {
        isEachWay: false,
        isSelected: true,
        rewardTokenId: null,
        stake: null,
        actualStake: null,
        isLocked: false,
        order: 0,
    };
}
